import React from 'react';
import {Box, Grid, Step, StepContent, StepLabel, Stepper, Typography} from '@mui/material';

interface GuideProps {
    photoUrl: string;
    heading: string;
    ingredients: string[];
    methodSteps: string[];
}

const Guide = ({photoUrl, heading, ingredients, methodSteps}: GuideProps) => {
    return (
        <Box>
            <img src={photoUrl} alt="Recipe" style={{width: '100%', height: 'auto'}}/>
            <Typography variant="h4" mt={"0.5em"} mx={"0.25em"} gutterBottom>{heading}</Typography>
            <Grid container spacing={2} mx={"0.5em"}>
                {ingredients.map((ingredient, index) => (
                    <Grid item xs={4} key={index}>
                        <Typography variant="caption">{ingredient}</Typography>
                    </Grid>
                ))}
            </Grid>
            <Box mx={"0.5em"} mt={"1em"}>
                <Stepper orientation="vertical">
                    {methodSteps.map((step, index) => (
                        <Step key={index} active={true}>
                            <StepLabel>
                                <Typography variant="caption">{step}</Typography>
                            </StepLabel>
                            <StepContent>
                                <Typography variant="body1">Lorem ipsum</Typography>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </Box>
    );
};

export default Guide;